// =============================================================================
// Informativ Response Validation
//
// The CBC/Informativ ADD_USER response includes ERROR and ERROR_DESCRIPT tags.
// Per the CBC XML guide, if ERROR is "True" the user was NOT added and the
// response must not be treated as a success. These helpers make sure a failed credit pull can never 
// silently pass through.
// =============================================================================

interface InformativResponse {
  XML_INTERFACE?: {
    ERROR?: { _text?: string };
    ERROR_DESCRIPT?: { _text?: string };
    CUS_ID?: { _text?: string };
  };
}

const ERROR_TRUE = "True";

/**
 * Returns the error description if the Informativ response indicates a failure,
 * otherwise returns null.
 */
export const extractInformativError = (
  response: InformativResponse
): string | null => {
  const error = response?.XML_INTERFACE?.ERROR?._text;
  const description = response?.XML_INTERFACE?.ERROR_DESCRIPT?._text;

  if (error === ERROR_TRUE) {
    return description || "Informativ registration failed with no description.";
  }

  return null;
};

/**
 * Extracts the CUS_ID from a successful Informativ response.
 */
export const extractCusId = (response: InformativResponse): string | undefined =>
  response?.XML_INTERFACE?.CUS_ID?._text;




